const stable = (value: unknown): string => JSON.stringify(value, (_key, item) => item && typeof item === 'object' && !Array.isArray(item) ? Object.fromEntries(Object.keys(item).sort().map(key => [key, item[key]])) : item);
/** Only acknowledge the same generated cover; never rebase unrelated story edits. */
export function canResumeCoverImageConflict(local: Record<string, any>, remote: Record<string, any>): boolean {
  const job = local.surfaceImageJobs?.story_cover;
  if (!job?.runId || remote.lastCoverImageRunId !== job.runId || job.status !== 'ready') return false;
  const image = remote.landingPresentation?.coverImage;
  if (typeof image !== 'string' || !image.startsWith('gateway-private://story-assets/') || local.landingPresentation?.coverImage !== image) return false;
  const comparable = (value: Record<string, any>) => {
    const copy = structuredClone(value);
    delete copy.lastCoverImageRunId;
    if (copy.surfaceImageJobs?.story_cover?.runId === job.runId) copy.surfaceImageJobs.story_cover.status = 'ready';
    return stable(copy);
  };
  return comparable(local) === comparable(remote);
}
